import { IComment } from "../../Services/CommentService";
import { IDetailedActivityEvent } from "../DetailedActivityStream/DetailedActivityStream";

export const mapCommentToActivityEvent = (comment: IComment): IDetailedActivityEvent => ({
    uuid: comment.uuid,
    eventType: "comment",
    contentTypeIcon: "pi pi-comment",
    contentTypeDescription: "Opmerking",
    payload: { text: comment.body },
    actorName: comment.createdBy?.name || comment.createdBy?.code,
    createdBy: comment.createdBy?.uuid ?? undefined,
    createdAt: comment.createdAt,
});

export const isCommentActivityEvent = (event: IDetailedActivityEvent): boolean => {
    const eventType = (event.eventType || "").toLowerCase();
    return eventType === "comment" || eventType === "message" || eventType === "comment_added";
};
